import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "text-sm"
};
const _hoisted_2 = {
  class: "border-b flex items-center justify-center p-2"
};
const _hoisted_3 = {
  class: "w-36"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "p-2 bg-green-50 h-[28rem] relative"
};
import PlayerSlot from "./lineup-formation/PlayerSlot.vue";
import PlayerSelection from "@/modules/team/components/lineup-formation/PlayerSelection.vue";
import FormationPicker from "@/modules/team/components/FormationPicker.vue";
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import LineupSkillCalculator from "@/modules/team/services/LineupSkillCalculator";
import { nextTick } from "vue";
import RandomLineupper from "@/modules/ai/services/lineupper/RandomLineupper";
import BestMatchingLineupper from "@/modules/ai/services/lineupper/BestMatchingLineupper";
import EffectiveLineupSkillCalculator from "@/modules/team/services/EffectiveLineupSkillCalculator";
import LineupHandler from "@/modules/team/services/LineupHandler";
export default /*#__PURE__*/_defineComponent({
  __name: 'LineupFormation',
  props: {
    team: null,
    canChange: {
      type: Boolean
    },
    nextMatch: null
  },
  emits: ['reset', 'change-formation', 'updated'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const playerSelection = ref(null);
    const formations = app.get(ConfigRepository).get('formations.all');
    const formation = computed(() => formations[props.team.formation]);
    const showEffectiveSkill = ref(false);
    const linedupSkill = computed(() => app.get(LineupSkillCalculator).calculateLinedupSkill(props.team.players, formation.value));
    const linedupEffectiveSkill = computed(() => app.get(EffectiveLineupSkillCalculator).calculateLinedupSkill(props.team.players, formation.value));
    const onClick = (lineup, position) => {
      if (!props.canChange) {
        return;
      }
      playerSelection.value.show(lineup, position);
    };
    const onChangeFormation = formation => emit('change-formation', formation);
    const {
      doLoading
    } = useLoading();
    const random = () => doLoading(async () => {
      await app.get(RandomLineupper).lineup(props.team, props.nextMatch);
      emit('reset');
    });
    const best = () => doLoading(async () => {
      await app.get(BestMatchingLineupper).lineup(props.team, props.nextMatch);
      emit('reset');
    });
    const reset = () => doLoading(async () => {
      await nextTick(async () => {
        await app.get(LineupHandler).reset(props.team.players);
        emit('reset');
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.canChange ? (_openBlock(), _createBlock(FormationPicker, {
        key: 0,
        size: "small",
        "model-value": __props.team.formation,
        "onUpdate:modelValue": onChangeFormation
      }, null, 8, ["model-value"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(formation).name), 1))]), _hoisted_5, __props.canChange && _ctx.$debug ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("a", {
        href: "#",
        class: "py-1 mr-4",
        onClick: _withModifiers(best, ["prevent"])
      }, _toDisplayString(_ctx.$t('best')), 9, _hoisted_6), _createElementVNode("a", {
        href: "#",
        class: "py-1 mr-4",
        onClick: _withModifiers(random, ["prevent"])
      }, _toDisplayString(_ctx.$t('random')), 9, _hoisted_7), _createElementVNode("a", {
        href: "#",
        class: "py-1 mr-4",
        onClick: _withModifiers(reset, ["prevent"])
      }, _toDisplayString(_ctx.$t('reset')), 9, _hoisted_8)], 64)) : _createCommentVNode("", true), !showEffectiveSkill.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "bg-gray-600 text-gray-100 font-bold px-4 py-1 rounded cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => showEffectiveSkill.value = !showEffectiveSkill.value)
      }, _toDisplayString(_unref(linedupSkill)), 1)) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "bg-green-600 text-green-100 font-bold px-4 py-1 rounded cursor-pointer",
        onClick: _cache[1] || (_cache[1] = $event => showEffectiveSkill.value = !showEffectiveSkill.value)
      }, _toDisplayString(_unref(linedupEffectiveSkill)), 1))]), _createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, i => {
        return _createVNode(PlayerSlot, {
          key: i,
          position: _unref(formation)[i].position,
          formation: _unref(formation),
          player: (__props.team.players ?? []).find(p => p.lineup === i),
          "hide-form": !__props.team.user,
          "hide-energy": !__props.team.user,
          style: _normalizeStyle({
            left: `${_unref(formation)[i].x}%`,
            top: `${_unref(formation)[i].y}%`
          }),
          class: "absolute -translate-x-1/2 cursor-pointer",
          "next-match": __props.nextMatch,
          onClick: $event => onClick(i, _unref(formation)[i].position)
        }, null, 8, ["position", "formation", "player", "hide-form", "hide-energy", "style", "next-match", "onClick"]);
      }), 64))]), _createVNode(PlayerSelection, {
        ref_key: "playerSelection",
        ref: playerSelection,
        players: __props.team.players,
        formation: _unref(formation),
        "next-match": __props.nextMatch,
        onUpdated: _cache[2] || (_cache[2] = $event => _ctx.$emit('updated'))
      }, null, 8, ["players", "formation", "next-match"])]);
    };
  }
});